import { Component, ReactNode } from 'react';
import userAgent, { IPlatformParams } from '../../utils/userAgent';

interface IProps {
  readonly children: (params: IPlatformParams) => ReactNode;
}

export default class BrowserSpecific extends Component<IProps> {
  private params = userAgent();

  public render() {
    return this.props.children(this.params);
  }
}
